import React, { useState } from "react";

import { Button, Grid, Typography } from "@mui/material";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  EngineDetail,
  EngineDetailItem,
  emptyEngine,
} from "components/forms/EngineDetail";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { createEngines } from "api/automation";

export const CreateEngines = ({ history }) => {
  const { currentSpace, currentEnvironment, token } = useUserContext();
  const setError = useSetError();

  const [enginesData, setEnginesData] = useState<EngineDetailItem[]>([
    { ...emptyEngine },
  ]);

  const handleSubmit = async () => {
    if (enginesData?.length && currentEnvironment?.id) {
      try {
        await createEngines(token, currentEnvironment.id, enginesData);
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error);
      }
    } else {
      setError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const handleAdd = () => {
    setEnginesData((prev) => [...prev, { ...emptyEngine }]);
  };

  const handleEngineUpdate = (
    updatedEngine: EngineDetailItem,
    position: number
  ) => {
    if (enginesData?.length) {
      const updated = [...enginesData];
      updated.splice(position, 1, updatedEngine);
      setEnginesData(updated);
    }
  };

  const handleEngineDelete = (position: number) => {
    const updated = [...enginesData];
    updated.splice(position, 1);
    setEnginesData(updated);
  };

  return (
    <PageStandard title="Motores" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      {!!enginesData?.length &&
        enginesData.map((item, position) => {
          return (
            <EngineDetail
              key={position}
              engineData={item}
              enginePos={position}
              onChange={(updated) => handleEngineUpdate(updated, position)}
              onDelete={() => handleEngineDelete(position)}
            />
          );
        })}

      {!!enginesData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de motores
        </Button>
      )}
    </PageStandard>
  );
};
